import _ from "lodash";
import { parseJson } from '@/utils';

// Simplified version for va-order-test
export function formatDataForFrontendTable(data) {
  const res = {};
  for (const key in data) {
    res[key] = data[key].map((obj, idx) => parseObjectFromApi(obj, idx, key));
  }
  return res;
}

export function parseObjectFromApi(obj, index, key = null) {
  const {
      id,
      name,
      type,
      description,
      currency,
      active,
      price,
      picture,
      return_and_refund_info,
      updated_at,
      status,
      creator_type,
      applicable_promotion,
      priceInEditOrder,
      quantityInEditOrder,
      orderedDate,
      taxCode,
      apply_to_self,
      apply_to_all_providers,
      apply_merchandise_info_to
  } = obj;

  const currencyObj = parseJson(localStorage.getItem("currency"), { name: "USD", symbol: "$"});
  const currencySign = currencyObj.symbol;
  const formattedPrice = currencySign + price.toFixed(2);
  const isAll = apply_to_all_providers;
  const isSelf = apply_to_self;
  let belongToProvider = null;
  if ((isSelf || creator_type === "provider") && key) {
    belongToProvider = key;
  }
  const providerList = apply_merchandise_info_to
                        ? apply_merchandise_info_to
                        : isSelf
                          ? [belongToProvider]
                          : [];
  let currentPrice = price;
  let price_after_promo = "";

  const isInEditOrder = Boolean(quantityInEditOrder)

  let promo = null;
  if (Array.isArray(applicable_promotion) && applicable_promotion.length > 0) {
    promo = applicable_promotion[0]
  } else {
    promo = applicable_promotion
  }

  if (isInEditOrder) {
    currentPrice = priceInEditOrder;
  } else if (promo && promo.active) {
    if (promo.discount_type === "percentage_off") {
      currentPrice *=  1 - promo.discount_value;
    } else {
      currentPrice -= promo.discount_value;
    }
    currentPrice = currentPrice >= 0 ? currentPrice : 0;
  }
  price_after_promo = currencySign + currentPrice.toFixed(2);

  let formattedreturnDays = null;
  let returnDaysNum = null;
  if (return_and_refund_info && return_and_refund_info.accept_return_refund) {
    returnDaysNum = return_and_refund_info.accepted_return_refund_days;
  }

  const orderedDateObj = new Date(orderedDate);
  const returnDeadline = orderedDate ? new Date(orderedDateObj) : null;
  if (returnDeadline) {
    returnDeadline.setDate(returnDeadline.getDate() + returnDaysNum);
  }
  const now = new Date();

  let isShow = true;
  let editable = true;

  if (!isInEditOrder) {
    isShow = active;
  }
  else {
    editable = returnDeadline > now;
  }
  return {
      index,
      id,
      update: updated_at,
      name,
      type,
      description,
      currency,
      stock: -1,
      price: formattedPrice,
      image: picture,
      promotion: null,
      return_and_refund_info,
      returnDays: formattedreturnDays,
      returnDaysNum,
      status,
      isShow,
      editable,
      returnDeadline,
      price_after_promo,
      originalPrice: price,
      currentPrice,
      isInEditOrder,
      quantityInEditOrder,
      orderedDate,
      taxCode: taxCode ? taxCode : null,
      creator_type,
      isAll,
      isSelf,
      providerList,
      belongToProvider,
  };
}
